// Modules
import React from 'react';
import PropTypes from 'prop-types';
// Components
import PromoBlockItem from './PromoBlockItem/PromoBlockItem';
// Helpers
import getLocalizedData from '../../utils/getLocalizedData';
// Styles
import * as styles from './promoBlock.scss';

const PromoBlock = props => {
  const renderPromoItems = (item, idx) => {
    const { result: description } = getLocalizedData(item.description, props.locale);
    return (
      <PromoBlockItem
        contentText={description}
        key={`company_promo_description_${idx}`}
      />
    );
  };

  return (
    <div className={styles.promoWrap}>
      <div className={styles.title}>{props.title}</div>
      <div className={styles.promoBlock}>
        {props.advantages.map(renderPromoItems)}
      </div>
    </div>
  );
};

PromoBlock.propTypes = {
  title: PropTypes.func,
  advantages: PropTypes.array,
  locale: PropTypes.string
};

export default PromoBlock;
